<h1 class="headline-1-bold" matDialogTitle>{{data.title}}</h1>
<div [innerHTML]="data.text" mat-dialog-content></div>
<div mat-dialog-content>
    <form action="" *ngIf="!data.hideFeedbackInput">
        <mat-form-field>
            <mat-label>Feedback in the Email</mat-label>
            <textarea matInput [formControl]="feedbackField"></textarea>
            <mat-error *ngIf="feedbackField.hasError('required')">Please provide feedback for the user</mat-error>
        </mat-form-field>
    </form>
</div>
<div class="feedback-dialog__buttons" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="16px">
    <div class="feedback-dialog__checkbox" [ngClass]="{'feedback-dialog__checkbox--visible': data.isCheckboxVisible}">
        <mat-checkbox [(ngModel)]="checkboxValue">{{data.checkboxLabel}}</mat-checkbox>
    </div>

    <button *ngIf="!data.hideCancel" (click)="closeDialog(false)" color="accent" mat-stroked-button class="text-wrap">
        {{data?.cancelBtnText || 'Cancel'}}
    </button>
    <button (click)="closeDialog(true, feedbackField.value)" color="accent" mat-raised-button class="text-wrap"
        [disabled]="!form.valid && !data.hideFeedbackInput">
        {{data?.okBtnText || 'OK'}}
    </button>
</div>